import React, { useEffect, useState, Fragment, useRef, useContext } from 'react';
import { LoginContext } from '../../hooks/context/LoginContext';
import $ from 'jquery';
import jQuery from 'jquery';
import DataTable from 'datatables.net';
import Spinner from 'react-bootstrap/Spinner';
import ReactDOM from 'react-dom';
import Cookies from 'universal-cookie';
import DatePicker from 'rsuite/DatePicker';
import 'rsuite/DatePicker/styles/index.css';
import axios from 'axios';
import { alertService } from '../../services/alertservice';

import {getDatePickerDaysName, getApiUrl } from '../../helpers/helperApp';

// JS
import 'datatables.net';              // DataTables core
import 'datatables.net-dt';           // DataTables base para estilo DT
import 'datatables.net-bs4';          // Integración con Bootstrap 4
import 'datatables.net-buttons';      // Buttons core
import 'datatables.net-buttons-bs4';  // Buttons para Bootstrap 4
import 'datatables.net-buttons/js/buttons.colVis.js';
import 'datatables.net-buttons/js/buttons.html5.js';
import 'datatables.net-buttons/js/buttons.print.js';
import 'datatables.net-select';       // Select (debe ir después de DataTables)
import 'datatables.net-rowreorder';
import 'datatables.net-rowgroup';
import 'datatables.net-responsive';   // Responsive core
//import 'datatables.net-plugins/sorting/natural.js';

$.DataTable = DataTable;

let date = new Date();
let mesHoy = date.getMonth() + 1;
let h = date.getDate();
let hoy = (h < 10 ? h = '0'+h : h = h )+'/'+(mesHoy < 10 ? mesHoy = '0'+mesHoy : mesHoy = mesHoy )+'/'+date.getFullYear();


function MiDataTableStockActivity(props){
    let botones = [
        {
            extend: 'pageLength',
            text: `<i style='font-size: 20px;' class='fal fa-list-ol'></i>`,
            className: 'btn btn-flat mr-1 btn-outline-secondary',
            // titleAttr: 'Ver número de registros'
        },
        // {
        //     extend: 'copy',
        //     text: `<i style='font-size: 20px;' class='fal fa-copy'></i>`,
        //     className: 'btn btn-flat mr-1 btn-outline-secondary',
        //     // titleAttr: 'Copiar al portapapeles',
        //     exportOptions: {
        //         columns: ':visible'
        //     }
        // }, 
        // {
        //     extend: 'csv',
        //     filename: hoy,
        //     text: `<i style='font-size: 20px;' class='fal fa-file-csv'></i>`,
        //     className: 'btn btn-flat mr-1 btn-outline-secondary',
        //     title: hoy,
        //     // titleAttr: 'Exportar a csv',
        //     exportOptions: {
        //         columns: ':visible'
        //     }
    
        // },
        {
            extend: 'excel',
            filename: hoy,
            text: `<i style='font-size: 20px;' class='fal fa-file-excel'></i>`,
            className: 'btn btn-flat mr-1 btn-outline-secondary',
            title: hoy,
            // titleAttr: 'Exportar a excel',
            exportOptions: {
                columns: ':visible'
            }
        }, 
        {
            extend: 'pdf',
            filename: hoy,
            text: `<i style='font-size: 20px;' class='fal fa-file-pdf'></i>`,
            className: 'btn btn-flat mr-1 btn-outline-secondary',
            orientation: 'landscape', 
            title: hoy,
            // titleAttr: 'Exportar a pdf',
            exportOptions: {
                columns: ':visible'
            }
        }, 
        // {
        //     extend: 'print',
        //     filename: hoy,
        //     text: `<i style='font-size: 20px;' class='fal fa-print'></i>`,
        //     className: 'btn btn-flat mr-1 btn-outline-secondary',
        //     title: hoy,
        //     // titleAttr: 'Imprimir',
        //     customize: function ( win ) {
        //         $(win.document.body)
        //             .css( 'font-size', '22pt' );
    
        //         $(win.document.body).find( 'table' )
        //             .addClass( 'compact' )
        //             .css( 'font-size', '14pt' );
        //     },
        //     exportOptions: {
        //         modifier: {
        //             selected: null
        //         }
        //     },
        //     exportOptions: {
        //         columns: ':visible'
        //     }
        // },
        {
            extend: 'colvis',
            text: `<i style='font-size: 20px;' class='fad fa-line-columns'></i>`,
            className: 'btn btn-flat mr-1 btn-outline-secondary',
        }
    ];


    const cookies = new Cookies();

    // ***** props *****
    const { id, data, columnas, formulario, selectId, selectIds, selectIdsKeySearch } = props;
    let { buttons, ordering, order, searching, paging, select, saveLoadingTable, loadingTable, traduction, functionClickTd, pagelength, txtFilterTable, noDisplay, rowreorder, functionAfterReorder, functionAfterSelect, saveData, getLineas, accionFn, historialFn, idPlantilla, idCentro, idUbicacion } = props; 
    
    const {loginState, apiKey} = useContext(LoginContext);

    const [noDisplayState, saveNoDisplayState] = useState(noDisplay);  
    const [haySeleccion, setHaySeleccion] = useState(false);
    const [numSeleccionadas, setNumSeleccionadas] = useState(0);
    const prevIdUbicacion = useRef(idUbicacion);
    const [loading, saveLoading] = useState(false);
  
    
    const fileInputRef = useRef(null);

    const existenBotones = (botones) => {    
        let data = false;
        botones.map(boton => {                    
            if(boton[0] != undefined){
                if(boton[0].className.includes('btnSeleccion')){
                    data = true;
                }
            }
        })
        return data;
    }

    // En las tablas que tengan activadas la selección le metemos las opciones de "Marcar todo", "Desmarcar Todo" e "Invertir selección"
    if( select !== undefined && select !== false ){
        if( select.style == "multi" ){
            if( !existenBotones(botones) ){
                const newBtns = [
                    {
                        extend: 'collection',
                        text: "<i style='font-size: 20px' class='fal fa-check'></i>",
                        className: 'btn btn-flat mr-1 btn-outline-secondary btnSeleccion',
                        buttons: [
                            {
                                // text: "<i style='font-size: 20px' class='fas fa-ballot-check'></i>",
                                text: "<i style='font-size: 20px' class='fal fa-check-square'></i>",
                                className: 'dt-button buttons-columnVisibility',
                                action: function ( e, dt, node, config ) {
                                    actionsBtnSelector( 0 );
                                }
                            },
                            {
                                // text: "<i style='font-size: 20px' class='fal fa-ballot-check'></i>",
                                text: "<i style='font-size: 20px' class='fal fa-square'></i>",
                                className: 'dt-button buttons-columnVisibility',
                                action: function ( e, dt, node, config ) {
                                    actionsBtnSelector( 1 );
                                }
                            },
                            {
                                // text: "<i style='font-size: 20px' class='fad fa-ballot-check'></i>",
                                text: "<i style='font-size: 20px' class='fas fa-check-square'></i>",
                                className: 'dt-button buttons-columnVisibility',
                                action: function ( e, dt, node, config ) {
                                    actionsBtnSelector( 2 );
                                }
                            }
                        ]
                    }
                ];
                botones.push(newBtns);
            }
        }
    }
    
    useEffect(()=>{        

        const ubicacionHaCambiado = prevIdUbicacion.current !== idUbicacion;
        prevIdUbicacion.current = idUbicacion;
                    
        buttons === undefined || buttons === true || buttons === "true" ? buttons = 'Bfrtip' : buttons = 'frtip';
        ordering === undefined ? ordering = true : ordering = ordering;
        order === undefined ? order = [[0,"asc"]] : order = order;
        searching === undefined ? searching = true : searching = searching;
        paging === undefined ? paging = true : paging = paging;
        pagelength === undefined ? pagelength = traduction.defaultpagelength : pagelength = pagelength;
        select === undefined ? select = false : select = select;
        
        
        columnas.map((columna, i) => {
            if( i == 1 || i == 2){
                // Existencias
                columna.createdCell = (td, cellData, rowData, row, col) => {                   
                    $(td).addClass("text-right");                    
                }
            }
            if( i == 6){
                // Acciones
                columna.createdCell = (td, cellData, rowData, row, col) => {
                    let templateNecesario =  ReactDOM.render(                       
                        <div className={"text-center"} >
                            <button type="button" className="btn btn-outline-success" onClick={e => {accionFn(e, rowData, 0)}}>
                                Retirar
                                {/* <i className="fa-light fa-minus" ></i> */}
                            </button>
                            <button type="button" className="btn btn-outline-success ml-1" onClick={e => {accionFn(e, rowData, 1)}}>
                                Añadir
                                {/* <i className="fa-light fa-plus" ></i> */}
                            </button>
                            <button type="button" className="btn btn-outline-primary ml-1" onClick={e => {historial(e, rowData)}}>
                                <i className="fa-light fa-clock-rotate-left" ></i>
                            </button>
                        </div>                                                    
                    ,td);
                    $(td).addClass(rowData.style);
                    $(td).html(templateNecesario)                                        
                }
            }
        })


        const handleFecha = (val, event, name, idLin) => {
            let nuevaFec;                        
            if(val == null){            
                nuevaFec = '';                
            }else{     
                val = new Date(val);
                const anho = val.getFullYear()
                const mes = val.getMonth()+1 < 10 ? '0'+(val.getMonth()+1) : val.getMonth()+1;
                const dia = val.getDate() < 10 ? '0'+val.getDate() : val.getDate();
                const horas = val.getHours() < 10 ? '0' + val.getHours() : val.getHours(); 
                const minutos = val.getMinutes() < 10 ? '0' + val.getMinutes() : val.getMinutes();
                nuevaFec = `${anho}-${mes}-${dia}T${horas}:${minutos}`;
            }

            // Actualizar objeto interno SIN redraw
            const table = $("#" + id).DataTable();
            const row = table.row('#row-' + idLin);
            const dataInterna = row.data();
            dataInterna.fecha = nuevaFec; 
            
            evaluarSeleccionFila(id, idLin);
        }

        const handleChangeCantidad = (e, rowData, idLin) => {            
            // Actualizar objeto interno SIN redraw
            const table = $("#" + id).DataTable();
            const row = table.row('#row-' + rowData.id);
            const dataInterna = row.data();
            dataInterna.cantidad = e.target.value;  

            evaluarSeleccionFila(id, idLin);
        }

        const handleChangeDescripcion = (e, rowData, idLin) => {                        
            // Actualizar objeto interno SIN redraw
            const table = $("#" + id).DataTable();
            const row = table.row('#row-' + rowData.id);
            const dataInterna = row.data();
            dataInterna.descripcion = e.target.value; 
            
            evaluarSeleccionFila(id, idLin);
        };

        // Bloquear la selección por click en inputs
        $('#' + id).on('user-select.dt', function (e, dt, type, cell, originalEvent) {                        
            if ($(originalEvent.target).closest('input, textarea, select, span, button').length) {
                e.preventDefault();
            }
        });        
        

        function evaluarSeleccionFila(idTabla, idLin) {
            // Seleccionamos al editar los input. 
            // Si vaciamos el input y todos los del row están vacíos quitamos la selección
            const table = $("#" + idTabla).DataTable();
            const row = table.row('#row-' + idLin);
            const data = row.data();
            
            const campos = ["cantidad", "descripcion"];
                        
            const algunoConValor = campos.some(campo => {
                const v = data[campo];                
                return v !== null && v !== undefined && v !== "";
            });

            if (algunoConValor) {
                row.select();
            } else {
                row.deselect();
            }
        }


        const historial = (e, rowData) => {                    
            historialFn(e, rowData);
        }

        if( data ){
            if( data.length > 0 ){
                if ( $.fn.DataTable.isDataTable("."+id) ) {
                    let oTable = $("."+id).DataTable();
                    let selectedIds = [];

                    if(ubicacionHaCambiado){
                        selectedIds = oTable.rows({ selected: true }).data().toArray().map(r => r.id);
                    }

                    // Reseteamos los row seleccionados al recargar la tabla menos si modificamos la ubicación
                    if(!ubicacionHaCambiado){
                        oTable.rows().deselect();
                        setHaySeleccion(false);
                        setNumSeleccionadas(0);
                    }

                    oTable.clear();

                    for (let i = 0; i < data.length; i++){
                        oTable.row.add(data[i]);
                    }

                    oTable.draw();

                    if(ubicacionHaCambiado && selectedIds.length){
                        selectedIds.forEach(idSel => {
                            oTable.row('#row-'+idSel).select();
                        });
                    }

                }else{
                    $("."+id).DataTable({
                        mark: true,
                        rowId: function(a) {
                            return 'row-' + a.id;},
                        dom: buttons,
                        data: data,
                        columns: columnas,
                        ordering: ordering,
                        order: order,
                        searching: searching,
                        paging: paging,
                        select: select,
                        buttons: [botones],
                        // fixedHeader: true,
                        // scrollX: true,
                        responsive: false, 
                        autoWidth: false,
                        retrieve: true,
                        pageLength: parseInt(pagelength),
                        lengthMenu: [
                            [ 10, 25, 50, 100 ],
                            [ '10', '25', '50', '100' ]
                        ],
                        rowReorder: rowreorder ? true : false,
                        deferRender: true,
                        language: {
                            "sProcessing":    traduction.sprocessing.title,
                            "sLengthMenu":    traduction.slengthmenu.title,
                            "sZeroRecords":   traduction.szerorecords.title,
                            "sEmptyTable":    traduction.semptytable.title,
                            "sInfo":          traduction.sinfo.title,
                            "sInfoEmpty":     traduction.sinfoempty.title,
                            "sInfoFiltered":  traduction.sinfofiltered.title,
                            "sInfoPostFix":   traduction.sinfopostfix.title,
                            "sSearch":        traduction.ssearch.title,
                            "sUrl":           traduction.surl.title,
                            "sInfoThousands":  traduction.sinfothousands.title,
                            "sLoadingRecords": traduction.sloadingrecords.title,
                            "oPaginate": {
                                  "sFirst": "<<",
   "sLast": ">>",
   "sNext": ">",
   "sPrevious": "<"
                            },
                            "oAria": {
                                "sSortAscending":  traduction.ssortascending.title,
                                "sSortDescending": traduction.ssortdescending.title
                            },
                            select: {
                                rows: traduction.rows.title
                            },
                            buttons: {
                                copyTitle: traduction.copytitle.title,
                                copyKeys: traduction.copykeys.title,
                                copySuccess: {
                                    _: traduction.copysuccess.many.title,
                                    1: traduction.copysuccess.one.title
                                },
                            }        
                        },
                        rowCallback : function (row, data, index){ 
                            // Si td campo incluye un # asumimos que es un color con lo que se lo ponemos de fondo
                            for (let item of row.children) {
                                if( item.outerText.includes("#") ){
                                    item.bgColor = item.outerText;
                                    item.innerText = "";
                                }
                            }

                            // Columna 3 - Fecha
                            const tdFec = row.children[3];
                            ReactDOM.render(
                                <LoginContext.Provider value={loginState}>
                                    <div className="row">
                                        <div className="col-12" >                                              
                                            <DatePicker
                                                id={"inputfec-"+data.id}
                                                name={"inputfec-"+data.id}
                                                placeholder={' '}
                                                format={"yyyy-MM-dd HH:mm"}
                                                // value={ data.fecha == '0000-00-00T00:00' || data.fecha == '0000-00-00' || data.fecha == '0000-00-00 00:00' || data.fecha == '' ? null : new Date(data.fecha) }
                                                defaultValue={new Date(data.fecha)}
                                                onChange={ (value, event) => handleFecha(value, event, "inputfec-"+data.id, data.id) }
                                                readOnly={ "" }
                                                className={ "" }
                                                // showTime
                                                block={true}
                                                weekStart={1}
                                                locale={getDatePickerDaysName()}
                                                placement={'auto'}
                                                cleanable={false}
                                            />                             
                                        </div>                            
                                    </div>    
                                </LoginContext.Provider>,
                                tdFec
                            );
                            
                            // Columna 4 - Cantidad
                            const tdCant = row.children[4];
                            ReactDOM.render(
                                <LoginContext.Provider value={loginState}>
                                   <div className="row">
                                        <div className="col-12" >                           
                                            <input  
                                                type={ "number" } 
                                                className={ "form-control text-right input-mat"} 
                                                id={ "inputcant-"+data.id } 
                                                name={ "inputcant-"+data.id } 
                                                placeholder={ "" }
                                                // value={ data.cantidad }
                                                defaultValue={ data.cantidad }  
                                                onChange={ e => handleChangeCantidad(e, data, data.id) }                                   
                                            />  
                                        </div>                            
                                    </div>     
                                </LoginContext.Provider>,
                                tdCant
                            );
                            
                            // Columna 5 - Descripcion
                            const tdDesc = row.children[5];
                            ReactDOM.render(
                                <LoginContext.Provider value={loginState}>
                                    <div className="row">
                                        <div className="col-12" >                           
                                            <input  
                                                type={ "text" } 
                                                className={ "form-control "} 
                                                id={ "inputdesc-"+data.id } 
                                                name={ "inputdesc-"+data.id } 
                                                placeholder={ "" }
                                                // value={ data.descripcion }
                                                defaultValue={ data.descripcion }  
                                                onChange={ e => handleChangeDescripcion(e, data, data.id) }                                   
                                            />  
                                        </div>                            
                                    </div>    
                                </LoginContext.Provider>,
                                tdDesc
                            );

                        }
                    })
                }  
                // saveLoadingTable(false);       
            }else{
                if ( $.fn.DataTable.isDataTable("."+id) ) {
                    let oTable = $("."+id).DataTable();
                    oTable.clear();
                    oTable.draw();               
                }{               
                    $("."+id).DataTable({
                        mark: true,
                        rowId: function(a) {
                            return 'row-' + a.id;},
                        dom: buttons,
                        data: null,
                        columns: columnas,
                        ordering: ordering,
                        order: order,
                        searching: searching,
                        paging: paging,
                        select: select,
                        buttons: [botones],
                        // fixedHeader: true,
                        // scrollX: true,
                        responsive: false, 
                        autoWidth: false,
                        retrieve: true,
                        pageLength: parseInt(pagelength),
                        lengthMenu: [
                            [ 10, 25, 50, 100 ],
                            [ '10', '25', '50', '100' ]
                        ],
                        rowReorder: rowreorder ? true : false,
                        deferRender: true,
                        language: {
                            "sProcessing":    traduction.sprocessing.title,
                            "sLengthMenu":    traduction.slengthmenu.title,
                            "sZeroRecords":   traduction.szerorecords.title,
                            "sEmptyTable":    traduction.semptytable.title,
                            "sInfo":          traduction.sinfo.title,
                            "sInfoEmpty":     traduction.sinfoempty.title,
                            "sInfoFiltered":  traduction.sinfofiltered.title,
                            "sInfoPostFix":   traduction.sinfopostfix.title,
                            "sSearch":        traduction.ssearch.title,
                            "sUrl":           traduction.surl.title,
                            "sInfoThousands":  traduction.sinfothousands.title,
                            "sLoadingRecords": traduction.sloadingrecords.title,
                            "oPaginate": {
                                  "sFirst": "<<",
   "sLast": ">>",
   "sNext": ">",
   "sPrevious": "<"
                            },
                            "oAria": {
                                "sSortAscending":  traduction.ssortascending.title,
                                "sSortDescending": traduction.ssortdescending.title
                            },
                            select: {
                                rows: traduction.rows.title
                            },
                            buttons: {
                                copyTitle: traduction.copytitle.title,
                                copyKeys: traduction.copykeys.title,
                                copySuccess: {
                                    _: traduction.copysuccess.many.title,
                                    1: traduction.copysuccess.one.title
                                },
                            }         
                        },
                        rowCallback : function (row, data, index){
                            // Si td campo incluye un # asumimos que es un color con lo que se lo ponemos de fondo
                            for (let item of row.children) {
                                if( item.outerText.includes("#") ){
                                    item.bgColor = item.outerText;
                                    item.innerText = "";
                                }
                            }

                            // Columna 3 - Fecha
                            const tdFec = row.children[3];
                            ReactDOM.render(
                                <LoginContext.Provider value={loginState}>
                                    <div className="row">
                                        <div className="col-12" >                                              
                                            <DatePicker
                                                id={"inputfec-"+data.id}
                                                name={"inputfec-"+data.id}
                                                placeholder={' '}
                                                format={"yyyy-MM-dd HH:mm"}
                                                // value={ data.fecha == '0000-00-00T00:00' || data.fecha == '0000-00-00' || data.fecha == '0000-00-00 00:00' || data.fecha == '' ? null : new Date(data.fecha) }
                                                defaultValue={new Date(data.fecha)}
                                                onChange={ (value, event) => handleFecha(value, event, "inputfec-"+data.id, data.id) }
                                                readOnly={ "" }
                                                className={ "" }
                                                // showTime
                                                block={true}
                                                weekStart={1}
                                                locale={getDatePickerDaysName()}
                                                placement={'auto'}
                                                cleanable={false}
                                            />
                                        </div>                            
                                    </div>    
                                </LoginContext.Provider>,
                                tdFec
                            );                            
                            
                            // Columna 4 - Cantidad
                            const tdCant = row.children[4];
                            ReactDOM.render(
                                <LoginContext.Provider value={loginState}>
                                   <div className="row">
                                        <div className="col-12" >                           
                                            <input  
                                                type={ "number" } 
                                                className={ "form-control text-right input-mat"} 
                                                id={ "inputcant-"+data.id } 
                                                name={ "inputcant-"+data.id } 
                                                placeholder={ "" }
                                                // value={ data.cantidad }
                                                defaultValue={ data.cantidad }  
                                                onChange={ e => handleChangeCantidad(e, data, data.id) }                                   
                                            />  
                                        </div>                            
                                    </div>     
                                </LoginContext.Provider>,
                                tdCant
                            );
                            
                            // Columna 5 - Descripcion
                            const tdDesc = row.children[5];
                            ReactDOM.render(
                                <LoginContext.Provider value={loginState}>
                                    <div className="row">
                                        <div className="col-12" >                           
                                            <input  
                                                type={ "text" } 
                                                className={ "form-control "} 
                                                id={ "inputdesc-"+data.id } 
                                                name={ "inputdesc-"+data.id } 
                                                placeholder={ "" }
                                                // value={ data.descripcion }
                                                defaultValue={ data.descripcion }  
                                                onChange={ e => handleChangeDescripcion(e, data, data.id) }                                   
                                            />  
                                        </div>                            
                                    </div>    
                                </LoginContext.Provider>,
                                tdDesc
                            ); 

                        }
                    })
                }
                // saveLoadingTable(false);
            }
        }else{
            if ( $.fn.DataTable.isDataTable("."+id) ) {
                let oTable = $("."+id).DataTable();
                oTable.clear();
                oTable.draw();               
            }{               
                $("."+id).DataTable({
                    mark: true,
                    rowId: function(a) {
                        return 'row-' + a.id;},
                    dom: buttons,
                    data: null,
                    columns: columnas,
                    ordering: ordering,
                    order: order,
                    searching: searching,
                    paging: paging,
                    select: select,
                    buttons: [botones],
                    // fixedHeader: true,
                    // scrollX: true,
                    responsive: false, 
                    autoWidth: false,
                    retrieve: true,
                    pageLength: parseInt(pagelength),
                    lengthMenu: [
                        [ 10, 25, 50, 100 ],
                        [ '10', '25', '50', '100' ]
                    ],
                    rowReorder: rowreorder ? true : false,
                    deferRender: true,
                    language: {
                        "sProcessing":    traduction.sprocessing.title,
                        "sLengthMenu":    traduction.slengthmenu.title,
                        "sZeroRecords":   traduction.szerorecords.title,
                        "sEmptyTable":    traduction.semptytable.title,
                        "sInfo":          traduction.sinfo.title,
                        "sInfoEmpty":     traduction.sinfoempty.title,
                        "sInfoFiltered":  traduction.sinfofiltered.title,
                        "sInfoPostFix":   traduction.sinfopostfix.title,
                        "sSearch":        traduction.ssearch.title,
                        "sUrl":           traduction.surl.title,
                        "sInfoThousands":  traduction.sinfothousands.title,
                        "sLoadingRecords": traduction.sloadingrecords.title,
                        "oPaginate": {
                            "sFirst":    traduction.sfirst.title,
                            "sLast":    traduction.slast.title,
                            "sNext":    traduction.snext.title,
                            "sPrevious": traduction.sprevious.title
                        },
                        "oAria": {
                            "sSortAscending":  traduction.ssortascending.title,
                            "sSortDescending": traduction.ssortdescending.title
                        },
                        select: {
                            rows: traduction.rows.title
                        },
                        buttons: {
                            copyTitle: traduction.copytitle.title,
                            copyKeys: traduction.copykeys.title,
                            copySuccess: {
                                _: traduction.copysuccess.many.title,
                                1: traduction.copysuccess.one.title
                            },
                        }       
                    },
                    rowCallback : function (row, data, index){
                        // Si algún td incluye un # asumimos que es un color con lo que se lo ponemos de fondo
                        for (let item of row.children) {
                            if( item.outerText.includes("#") ){
                                item.bgColor = item.outerText;
                                item.innerText = "";
                            }
                        }    
                        
                        // Columna 3 - Fecha
                        const tdFec = row.children[3];
                        ReactDOM.render(
                            <LoginContext.Provider value={loginState}>
                                <div className="row">
                                    <div className="col-12" >                                      
                                        <DatePicker
                                            id={"inputfec-"+data.id}
                                            name={"inputfec-"+data.id}
                                            placeholder={' '}
                                            format={"yyyy-MM-dd HH:mm"}
                                            // value={ data.fecha == '0000-00-00T00:00' || data.fecha == '0000-00-00' || data.fecha == '0000-00-00 00:00' || data.fecha == '' ? null : new Date(data.fecha) }
                                            defaultValue={new Date(data.fecha)}
                                            onChange={ (value, event) => handleFecha(value, event, "inputfec-"+data.id, data.id) }
                                            readOnly={ "" }
                                            className={ "" }
                                            // showTime
                                            block={true}
                                            weekStart={1}
                                            locale={getDatePickerDaysName()}
                                            placement={'auto'}
                                            cleanable={false}
                                        />                            
                                    </div>                            
                                </div>    
                            </LoginContext.Provider>,
                            tdFec
                        );
                        
                        // Columna 4 - Cantidad
                        const tdCant = row.children[4];
                        ReactDOM.render(
                            <LoginContext.Provider value={loginState}>
                                <div className="row">
                                    <div className="col-12" >                           
                                        <input  
                                            type={ "number" } 
                                            className={ "form-control text-right input-mat"} 
                                            id={"inputcant-"+data.id } 
                                            name={ "inputcant-"+data.id } 
                                            placeholder={ "" }
                                            // value={ data.cantidad }
                                            defaultValue={ data.cantidad }  
                                            onChange={ e => handleChangeCantidad(e, data, data.id) }                                   
                                        />  
                                    </div>                            
                                </div>     
                            </LoginContext.Provider>,
                            tdCant
                        );
                        
                        // Columna 5 - Descripcion
                        const tdDesc = row.children[5];
                        ReactDOM.render(
                            <LoginContext.Provider value={loginState}>
                                <div className="row">
                                    <div className="col-12" >                           
                                        <input  
                                            type={ "text" } 
                                            className={ "form-control "} 
                                            id={ "inputdesc-"+data.id } 
                                            name={ "inputdesc-"+data.id } 
                                            placeholder={ "" }
                                            // value={ data.descripcion }
                                            defaultValue={ data.descripcion }  
                                            onChange={ e => handleChangeDescripcion(e, data, data.id) }                                   
                                        />  
                                    </div>                            
                                </div>    
                            </LoginContext.Provider>,
                            tdDesc
                        );
                    }
                })
            }
            // saveLoadingTable(false);            
        }

        if( saveLoadingTable ){
            saveLoadingTable(false); 
        }

        // Código para llamar a una función tras reordenar las filas
        if( functionAfterReorder != null  ){
            let tabla = $('#'+id).DataTable();
            tabla.on( 'row-reorder', function ( e, diff, edit ) {
                functionAfterReorder( e, diff, edit);         
            } );
        }

        // Código para llamar a una función tras seleccionar una fila
        if( functionAfterSelect != null  ){
            let tabla = $('#'+id).DataTable();
            
            // Eliminar cualquier listener existente para evitar duplicados
            tabla.off('click', 'tr');
            
            tabla.on( 'click', 'tr', function ( e, dt, type, indexes ) {                
                if(e.currentTarget.id != ""){
                    setTimeout(()=> {
                        let idRow = tabla.row( this ).id();         
                        const datos = $('#'+id).DataTable().rows().data();
                        const selectedRows = $('#'+id).DataTable().rows( { selected: true } ).data();
                        functionAfterSelect(idRow, id, datos, selectedRows);                                                
                    }, 500)
                }
            } );            
        }

        // Funcionalidad para habilitar/deshabilitar el botón de inventario y poner el número de registros seleccionados.
        const table = $("#" + id).DataTable();
        const actualizarEstadoSeleccion = () => {
            const count = table.rows({ selected: true }).count();
            setNumSeleccionadas(count);
            setHaySeleccion(count > 0);
        };

        table.on('select', actualizarEstadoSeleccion);
        table.on('deselect', actualizarEstadoSeleccion);

        return () => {
            table.off('select', actualizarEstadoSeleccion);
            table.off('deselect', actualizarEstadoSeleccion);
        };

        
    }, [data, formulario?.id, selectIds, idUbicacion])

    async function inventariar(){
        saveLoading(true);

        let oTable = $("."+id).DataTable();
        let lineasSeleccionadas = oTable.rows({ selected: true, search: 'applied' }).data().toArray();

        // Validar fechas
        const hayFechaInvalida = lineasSeleccionadas.some(linea => {
            if(!linea.fecha) return true;
            const fecha = new Date(linea.fecha);
            return isNaN(fecha.getTime());
        });

        if(hayFechaInvalida){
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>Todas los registros deben tener fecha`, {autoClose: false});
            saveLoading(false);
            return;
        }

        // Normalizar cantidades vacías
        lineasSeleccionadas = lineasSeleccionadas.map(linea => {            
            if ( linea.cantidad === "" || linea.cantidad === null || linea.cantidad === undefined) {
                linea.cantidad = "0";
            }
            return linea;
        });

        const data = new FormData();
        data.append("validacion", apiKey());
        data.append("lineas", JSON.stringify(lineasSeleccionadas)); 
        data.append("idcen", idCentro);
        data.append("idubi", idUbicacion);
        const respuesta = await axios.post(getApiUrl(window.location.origin)+'/stockactivity/inventariar', data);           
        if( typeof respuesta.data == "string" ){
            alertService.error(`<i class="fal fa-times-octagon mr-1"></i>${respuesta.data}`, {autoClose: false});            
        }else{
            alertService.success(`<i class="fal fa-times-octagon mr-1"></i>Registros añadidos correctamente`, {autoClose: true}); 
            oTable.rows({ search: 'applied' }).deselect();           
        }  

        await getLineas();
        saveLoading(false)
    }
    
    // Funcion que realiza las acciones de los botones de Marcar todos, Desmarcar todos e Invertir Selección
    function actionsBtnSelector ( boton ) {
        let oTable = $("."+id).DataTable();

        switch(boton){
            case 0:
                // Marcar todos
                oTable.rows({ search: 'applied' }).select();
                break;
            case 1:
                // Desmarcar todos
                oTable.rows({ search: 'applied' }).deselect();
                break;
            case 2:
                // Invertir selección
                let rows = oTable.rows( { selected: true, search: 'applied' } )[0];  
                oTable.rows({ search: 'applied' }).select();
                oTable.rows(rows).deselect();
                break;
        }
    }
    

    // Código para evitar los acentos en las búsquedas
    function removeAccents ( data ) {
        if ( data.normalize ) {
            // Use I18n API if avaiable to split characters and accents, then remove
            // the accents wholesale. Note that we use the original data as well as
            // the new to allow for searching of either form.
            return data +' '+ data
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '');
        }
     
        return data;
    }
    let searchType = jQuery.fn.DataTable.ext.type.search;
 
    searchType.string = function ( data ) {
        return ! data ?
            '' :
            typeof data === 'string' ?
                removeAccents( data ) :
                data;
    };
    
    searchType.html = function ( data ) {    
        return ! data ?
            '' :
            typeof data === 'string' ?
                removeAccents( data.replace( /<.*?>/g, '' ) ) :
                data;
    };
    // FIN: Código para evitar los acentos en las búsquedas 
    
    // Resaltar el row que estamos editando en los formularios
    if( formulario ){

        if( formulario.id != "" ){        
            detectSelectedLine(true);
        }

        $("."+id).on( 'page.dt', function () {
            detectSelectedLine();
        } );
    
        $("."+id).on( 'length.dt', function () {
            detectSelectedLine(true);
        } );
    }

    // Añadir clase a la línea del registro seleccionado
    function detectSelectedLine(go=false){        
        setTimeout(()=> {
            let trs = document.querySelectorAll("table#"+id+" tr.selectedRow");
            for( let i = 0; i < trs.length; i++ ){
                trs[i].classList.remove("selectedRow");
            }

            const tr = document.querySelector("span[id='"+formulario.id+"']");        
            if( tr ){
                tr.parentElement.parentElement.parentElement.classList.add("selectedRow");
            }

            if( go ){
                goToPage();
            }
            
        }, 100)
    }

    // Salta a la página del registro seleccionado
    function goToPage(){
        let oTable = $("."+id).DataTable();
        let info = oTable.page.info();

        // Utilizamos los registros filtrados a través del buscador
        const filteredRegs = oTable.rows( {search:'applied'} ).data();
        // let rows = oTable.rows().data();

        // Buscar la página del registro y saltar a ella
        let pos = 0;
        for( let i = 0; i < filteredRegs.length; i++ ){
            if( filteredRegs[i].id == formulario.id ){
                pos = i;
                break;
            }
        }
        if( pos > 0 ){
            oTable.page( Math.floor( pos / info.length ) ).draw( false );
        }
    }
    // FIN: Añadir clase a la línea del registro seleccionado

    // Seleccionar un id de la tabla
    if( selectIds ){        
        // setTimeout(()=> {                        
            if(selectIds != null  && selectIds.length > 0 ){
                let table = $("#"+id).DataTable();
                let rows = table.rows().data();
                let last = null;        
                let indexes = table.rows().indexes(); // Obtener índices globales           
                for(let i=0; i < rows.length; i++){
                    if( selectIds.includes(rows[i][selectIdsKeySearch]) ){                        
                        // table.row(':eq('+i+')', { page: 'current' }).select();
                        let globalIndex = indexes[i]; // Obtener índice global
                        table.row(globalIndex).select(); // Seleccionar fila globalmente
                        last = {id: rows[i][selectIdsKeySearch]};
                    }
                }
                
                if(last != null){
                    goToPage2(last);
                }
            }            
        // }, 100)
    }
    
    // Seleccionar un id de la tabla
    if( selectId ){        
        if( selectId.id != "" ){        
            detectSelectedLine2(selectId,true);
        }

        $("."+id).on( 'page.dt', function () {
            detectSelectedLine2(selectId);
        } );
    
        $("."+id).on( 'length.dt', function () {
            detectSelectedLine2(selectId,true);
        } );
    }
    function detectSelectedLine2(selectId, go=false){        
        setTimeout(()=> {
            if(selectId != null  && selectId.id ){                               
                let trs = document.querySelectorAll("table#"+id+" tr.selected");
                for( let i = 0; i < trs.length; i++ ){
                    trs[i].classList.remove("selected");
                }                              
                 
                let found = false;
                let table = $("#"+id).DataTable();
                let rows = table.rows().data();
                let indexes = table.rows().indexes(); // Obtener índices globales
                for(let i=0; i < rows.length; i++){
                    if( rows[i].id == selectId.id ){                        
                        // table.row(':eq('+i+')', { page: 'current' }).select();
                        let globalIndex = indexes[i]; // Obtener índice global
                        table.row(globalIndex).select(); // Seleccionar fila globalmente
                        const tr = document.getElementById(`#row-${selectId.id}`);                                               
                        if(tr){
                            tr.classList.add('selected')
                        }
                        found = true;
                    break;
                    }
                }

                // Si no se encontró el registro, borrar selectId para evitar futuras selecciones erróneas
                if (!found) {
                    selectId = null;
                }
    
                if( go ){
                    goToPage2(selectId);
                }
            }
            
        }, 100)
    }
    function goToPage2(selectId){
        let oTable = $("."+id).DataTable();
        let info = oTable.page.info();

        // Utilizamos los registros filtrados a través del buscador
        const filteredRegs = oTable.rows( {search:'applied'} ).data();
        // let rows = oTable.rows().data();

        // Buscar la página del registro y saltar a ella
        let pos = 0;
        for( let i = 0; i < filteredRegs.length; i++ ){
            if( filteredRegs[i].id == selectId.id ){
                pos = i;
                break;
            }
        }
        if( pos > 0 ){
            oTable.page( Math.floor( pos / info.length ) ).draw( false );
        }
        
        let table = $("#"+id).DataTable();
        let rows = table.rows().data();
        let indexes = table.rows().indexes(); // Obtener índices globales
        for(let i=0; i < rows.length; i++){
            if( rows[i].id == selectId.id ){                                        
                let globalIndex = indexes[i]; // Obtener índice global
                table.row(globalIndex).select(); // Seleccionar fila globalmente
                const tr = document.getElementById(`#row-${selectId.id}`);                                               
                if(tr){
                    tr.classList.add('selected')
                }                
            break;
            }
        }
    }    
    // FIN: Seleccionar un id de la tabla




    // Filtramos en la tabla un texto recibido como parámetros
    if( txtFilterTable != null && txtFilterTable != "" ){
        let tabla = $('#'+id).DataTable();
        tabla.search(txtFilterTable).draw();
    }


    return(
        <Fragment>
            {   loading ? 
                    <div style={{height:50, marginTop:5, marginBottom:10, textAlign: "center"}} >
                        <Spinner animation="border" />
                    </div>
                :
                null
            }
            <div className={noDisplayState ? "noDisplay" : ""} style={{overflowX: "auto"}}>
                <div className='col-12 text-center'>
                    <button 
                        style={{marginTop: "10px"}} 
                        id="btnaddline"
                        className={"btn btn-success col-md-2 col-sm-12 " } 
                        type="button" 
                        onClick={ inventariar } 
                        disabled={ loading == true || !haySeleccion || idPlantilla == 0 || idCentro == 0 || idUbicacion == 0 ? true : false }
                    >
                        {
                            haySeleccion 
                            ? `Enviar ${numSeleccionadas} registro${numSeleccionadas > 1 ? 's' : ''} a inventario`
                            : `Enviar registros a inventario`
                        }
                    </button>
                </div>
                <table id={id} className={id+" table table-sm table-bordered table-striped table-hover dataTable"} 
                    style={{
                        width:"100%",
                        cursor: functionClickTd ? "pointer" : "default"
                    }} 
                >
                </table>                
            </div>   
            
        </Fragment>
    )
}

export default MiDataTableStockActivity;